import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "agentKeys" */ './index'),
  loading: () => null,
});
